import { useMutation } from "@tanstack/react-query";
import { getShareToken, sendReportLinkWithSms } from "api/sms";

const useGetShareToken = () => {
  return useMutation({
    mutationFn: getShareToken,
  });
};

const useSendSMS = (setDelivered) => {
  const mutateSendSMS = useMutation({
    mutationFn: sendReportLinkWithSms,
    onSuccess: (res) => {
      if (res.status === 200)
        setDelivered(true);
    }
  });
  return mutateSendSMS;
};

export { useSendSMS, useGetShareToken };